import { Observable } from '../Observable';
import { from } from './from';
export function defer(observableFactory) {
    return new Observable(function (subscriber) {
        from(observableFactory()).subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map